module.exports = __webpack_public_path__ + "img/icon-groupe-neutre.48e79d24.svg";